import { render, staticRenderFns } from "./TransplantInProgressReport.vue?vue&type=template&id=4befd498&"
import script from "./TransplantInProgressReport.vue?vue&type=script&lang=ts&"
export * from "./TransplantInProgressReport.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports